<script>
    import Layout from "../../layouts/main";
    import PageHeader from "../../components/page-header";
    import supplierList from "./supplier-list";
    export default {
    components: { Layout, PageHeader, supplierList },
    data() {
        return {};
    }
    };

</script>

<template>
  <Layout>
    <supplier-list/>
  </Layout>
</template>